import { useContext } from 'react';
import { GeoPoint } from '../location/types';
import { UnitLocationContext } from './unit-location-context';

export function useUnitLocation(): GeoPoint | undefined {
    return useContext(UnitLocationContext);
}
